import { DocumentPaymentState } from '../../models/enums/document-payment-state';

export const DASHBOARD_COLOR_NAMES = ['indigo', 'teal', 'yellow', 'salmon', 'sky', 'purple', 'orange', 'green'] as const;
export type DashboardColorName = (typeof DASHBOARD_COLOR_NAMES)[number];

export const DOCUMENT_FORECAST_STATE_COLORS: Record<DocumentPaymentState, DashboardColorName> = {
	[DocumentPaymentState.Unpaid]: 'sky',
	[DocumentPaymentState.Paid]: 'green',
	[DocumentPaymentState.PaidExternally]: 'green',
	[DocumentPaymentState.ProcessedExternally]: 'teal',
	[DocumentPaymentState.PaymentPending]: 'indigo',
	[DocumentPaymentState.FundingPending]: 'salmon',
	[DocumentPaymentState.PaymentOrdered]: 'sky',
	[DocumentPaymentState.LockForTransaction]: 'purple',
	[DocumentPaymentState.Advanced]: 'indigo',
};

export const DOCUMENT_FORECAST_FALLBACK_COLOR = '#9e9e9e';

export function resolveDashboardColor(name: DashboardColorName): string {
	const value = getComputedStyle(document.documentElement).getPropertyValue(`--color-dashboard-${name}`).trim();
	return value || DOCUMENT_FORECAST_FALLBACK_COLOR;
}

